import React, { Component, useState } from "react";
import { graphql } from "gatsby"
import parse from "html-react-parser"
import { Asset } from "../../../../plugins/gatsby-plugin-atollon"
import { useKeenSlider } from "keen-slider/react"

class BlockUpdate extends Component {
  shouldComponentUpdate() {
    return false
  }
  render() {
    return (<>{ this.props.children }</>)
  }
}

const ImageGallerySlider = ({ title, images }) => {

  const animation = { duration: 30000, easing: (t) => t }
  const [currentSlide, setCurrentSlide] = useState(0)
  const [loaded, setLoaded] = useState(false)

  const [sliderRef, instanceRef] = useKeenSlider({
    loop: true,
    breakpoints: {
      "(max-width: 899px)": {
        slides: { perView: 'auto', spacing: 24 },
      },
      "(min-width: 900px)": {
        slides: { perView: 'auto', spacing: 90 },
      },
    },
    slides: {
      renderMode: "performance",
      drag: true,
    },
    created(s) {
      s.moveToIdx(5, true, animation);
      setLoaded(true)
    },
    updated(s) {
      s.moveToIdx(s.track.details.abs + 5, true, animation);
    },
    animationEnded(s) {
      s.moveToIdx(s.track.details.abs + 5, true, animation);
    },
    slideChanged(slider) {
      setCurrentSlide(slider.track.details.rel)
    },
    dragEnded(s) {
      setTimeout(() => {
        s.animator?.stop();
      }, 500);
    },
  });

  return (
    <section className="image-gallery-slider">
      <div className="image-gallery-slider__inner">
        {title && <h2 data-sal='slide-up' data-sal-duration='1000' data-sal-easing='ease'>{parse(title)}</h2>}
        <div className='image-gallery-slider__items keen-slider' data-sal='slide-up' data-sal-duration='1000' data-sal-easing='ease'  ref={sliderRef}>
          {
            images?.length > 0 && images.map((image, i) => {
              let aspectClass = ' image-gallery-slider__item--portrait'
              let aspectRatio = image.width / image.height
              if (aspectRatio > 1) aspectClass = ' image-gallery-slider__item--landscape'
              return (
                <div key={i} className={`image-gallery-slider__item keen-slider__slide${aspectClass}`}><Asset asset={image} /></div>
              )
            })
          }
          {
            images?.length > 0 && images.map((image, i) => {
              let aspectClass = ' image-gallery-slider__item--portrait'
              let aspectRatio = image.width / image.height
              if (aspectRatio > 1) aspectClass = ' image-gallery-slider__item--landscape'
              return (
                <div key={i} className={`image-gallery-slider__item keen-slider__slide${aspectClass}`}><Asset asset={image} /></div>
              )
            })
          }
          {
            images?.length > 0 && images.map((image, i) => {
              let aspectClass = ' image-gallery-slider__item--portrait'
              let aspectRatio = image.width / image.height
              if (aspectRatio > 1) aspectClass = ' image-gallery-slider__item--landscape'
              return (
                <div key={i} className={`image-gallery-slider__item keen-slider__slide${aspectClass}`}><Asset asset={image} /></div>
              )
            })
          }
          {
            images?.length > 0 && images.map((image, i) => {
              let aspectClass = ' image-gallery-slider__item--portrait'
              let aspectRatio = image.width / image.height
              if (aspectRatio > 1) aspectClass = ' image-gallery-slider__item--landscape'
              return (
                <div key={i} className={`image-gallery-slider__item keen-slider__slide${aspectClass}`}><Asset asset={image} /></div>
              )
            })
          }
        </div>
      </div>
    </section>
  )
}

export default ImageGallerySlider

export const query = graphql`
   fragment ImageGallerySliderProps on DatoCmsImageGallerySlider {
      ... on DatoCmsImageGallerySlider {
      title
      images {
        ...InternalAssetProps
      } 
    }
  }
`